// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__Summary__removeLinkStyle{color:var(--GW-LINK-COLOR);text-decoration:none}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-gateway-react/QuoteDetails/Summary/Summary.module.scss"],"names":[],"mappings":"AAAA,+BACI,0BAAA,CACA,oBAAA","sourcesContent":[".removeLinkStyle {\n    color: var(--GW-LINK-COLOR);\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"removeLinkStyle": "app__Summary__removeLinkStyle"
};
export default ___CSS_LOADER_EXPORT___;
